/**
 * @flow
 * @relayHash 7e6ee38fc081f7877bbf3201bb8a32ec
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCategoriesInput = {|
  ids: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type DeleteCategoriesMutationVariables = {|
  input: DeleteCategoriesInput
|};
export type DeleteCategoriesMutationResponse = {|
  +deleteCategories: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteCategoriesMutation = {|
  variables: DeleteCategoriesMutationVariables,
  response: DeleteCategoriesMutationResponse,
|};
*/


/*
mutation DeleteCategoriesMutation(
  $input: DeleteCategoriesInput!
) {
  deleteCategories(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCategoriesInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCategories",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCategoriesPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCategoriesMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCategoriesMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCategoriesMutation",
    "id": null,
    "text": "mutation DeleteCategoriesMutation(\n  $input: DeleteCategoriesInput!\n) {\n  deleteCategories(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f1e3aab3e75f2a405ee59e88d9881173';
module.exports = node;
